import { render } from "./CompanyDetail.vue?vue&type=template&id=96e964de"
import script from "./CompanyDetail.vue?vue&type=script&lang=js"
export * from "./CompanyDetail.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/kokoroduke-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__